<template>
<div class="card-body">
    <title-header title="Missão, visão e Valores"></title-header>
    <div class="content">
        <div class="card-valores">
            <p class="title">Nossa <strong>Missão</strong></p>
            <div class="separete-title"></div>
            <p>
                Promover maior integração dos 300 sindicatos com as seis Regionais da Central instaladas no Estado e com a UGT Nacional. Ampliar o número de filiados, estabelecendo estratégias de ação, respeitadas as peculiaridades de cada região, para o desenvolvimento dos trabalhadores das 69 categorias profissionais representadas.
            </p>
        </div>

        <div class="card-valores">
            <p class="title">Nossa <strong>Visão</strong></p>
            <div class="separete-title"></div>
            <p>
                Defender os trabalhadores paulistas por meio de um movimento sindical amplo, cidadão, ético, solidário, independente, democrático, apartidário e inovador. Defender a todo custo a liberdade, a autonomia e a unicidade sindical.
            </p>
        </div>

        <div class="card-valores">
            <p class="title">Nossos <strong>Valores</strong></p>
            <div class="separete-title"></div>
            <p>
                <ul class="card-text">
                    <li class="card-text">Responsabilidade Sindical e Social</li>
                    <li>Credibilidade</li>
                    <li>Solidariedade</li>
                    <li>Ética</li>
                    <li>Imparcialidade</li>
                    <li>Modernidade</li>
                    <li>Igualdade de Gêneros</li>
                </ul>
            </p>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "valores",
};
</script>

<style lang="scss" scoped>
.card-body {
    @apply p-20 pt-0;

    @media (max-width: 668px) {
        @apply p-8;
    }
    .content {
        @apply flex justify-between items-start m-8;
        @media (max-width: 768px) {
            @apply flex-col;
        }
        .card-valores {
            @apply w-3/12;
            @media (max-width: 768px) {
                @apply w-full mb-4;
            }
            .title {
                @apply flex flex-col justify-center items-center;
                strong {
                    @apply text-3xl;
                }
            }
            .separete-title {
                @apply w-full h-1 bg-primary m-3;
            }
            p {
                @apply text-center mb-2 text-base;
                line-height: 1.80rem;
            }
            ul {
                @apply list-inside;
            }
        }
    }
}
</style>
